module.exports = "/_next/static/videos/soccer-2-87c15bf9f0b11e2205269ccafd0fd1b7.webm";